import { UPDATE_BELEGUNG } from '@/domain/dienstplan/features/VisualEditor/hooks/useBelegungen/graphql/mutations';
import {
  Dienstplan_UpdateBelegungMutation,
  Dienstplan_UpdateBelegungMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

export function useUpdateBelegung() {
  const [execute, result] = useMutation<
    Dienstplan_UpdateBelegungMutation,
    Dienstplan_UpdateBelegungMutationVariables
  >(UPDATE_BELEGUNG, {
    refetchQueries: [
      'dienstplan_arbeitsbereichByStandortId',
      'dienstplan_getBelegungen',
    ],
    awaitRefetchQueries: true,
  });

  const updateBelegung = useCallback(
    (variables: Dienstplan_UpdateBelegungMutationVariables) => {
      return execute({ variables });
    },
    [execute],
  );
  return [updateBelegung, result] as const;
}
